import { ResAuthority } from "@/api";
import { TABS } from ".";
import { useMainStore } from "@/store";

/**
 * 报税
 * 勾选【报税平台】【个税申报】才有个税  之前这个权限只影响申报状态哈，不影响数据
 * 勾选报表里的【查询】才有所得税
 */
export enum POWER_NETFILE {
  TAX = "0902BS,0904GS",
  INCOME_TAX = "bbSel,0202JZ",
  JZ = "0202JZ",
}

/**
 * 财务
 * 勾选报表里的【查询】才能看见看见各报表
 * 勾选报表里的【导出】才有下载按钮
 * 勾选报表里的【打印】才有发送按钮
 */
export enum POWER_FIANCE {
  PRE = "0202JZ",
  NAME = "bbSel",
  EXPORT = "bbExl",
  PRINT = "bbPrint",
}

export enum POWER_INVOICE {
  PRE = "0202JZ",
}

/**
 * 合同
 * 勾选合同列表【查看】后才能看见进行中的合同
 * 勾选已终止合同列表【查看】后才能看见终止的合同
 * 勾选合同列表【添加】后才能有续签的按钮
 * 勾选收款单里的【添加】后才能有收款的按钮
 */
export enum POWER_CONTRACT {
  UNDERWAY = "0206S",
  TERMINATED = "0214S",
  RENEW = "0206A",
  RECEIPT = "0208A",
}

/**
 * 知识库
 * 勾选知识共享里的【查看】才可以看见知识库的内容
 * 勾选知识共享里的【添加】才能进行知识的添加
 * 勾选知识共享里的【修改】才能进行知识的编辑
 * 勾选知识共享里的【删除】才能进行知识的删除
 */
export enum POWER_KNOWLEDGE {
  VIEW = "0216S",
  ADD = "0216A",
  EDIT = "0216E",
  DELETE = "0216D",
}

// 4 标准版, 5发票版,6全税种, 7AI版
export enum C_I_TYPE {
  NORM = 4,
  INVOICE = 5,
  ALL = 6,
  AI = 7,
}

/**
 * 记账权限
 * 分版本: crs权限变更, 同步更改
 *
 */
const jzObj = {
  [C_I_TYPE.AI]: "2005S",
  [C_I_TYPE.ALL]: "3005S",
  [C_I_TYPE.INVOICE]: "4005S",
  [C_I_TYPE.NORM]: "5001S",
};
const bsObj = {
  [C_I_TYPE.AI]: "2008S",
  [C_I_TYPE.ALL]: "3008S",
  [C_I_TYPE.INVOICE]: "4008S",
  [C_I_TYPE.NORM]: "5008S",
};

export type ALL_POWER = POWER_CONTRACT | POWER_FIANCE | POWER_KNOWLEDGE | POWER_NETFILE;

/** 获取模块权限 */
export const judgeModulePower = (allPower: string): Powers => {
  try {
    console.groupCollapsed("获取模块权限", allPower);
    // 默认权限
    let o: Powers = {
      [TABS.CLIENT]: { module: true },
      [TABS.ARCHIVE]: { module: true },
    };
    // 遍历权限
    [
      [POWER_INVOICE, TABS.INVOICE, POWER_INVOICE.PRE],
      [POWER_NETFILE, TABS.NETFILE],
      [POWER_FIANCE, TABS.FINANCE, POWER_FIANCE.PRE],
      [POWER_CONTRACT, TABS.CONTRACT],
      [POWER_KNOWLEDGE, TABS.KNOWLEDGE],
    ].forEach((e) => {
      const [power, name, pre] = e as [ALL_POWER, TABS, string];
      o[name] = { module: false };
      let module = false;
      Object.values(power).forEach((n) => {
        const bol = judgeAlone(n as ALL_POWER, allPower);
        // console.log(n, bol);
        if (n == pre) module = bol;
        if (bol) o[name].module = true;
        o[name][n] = bol;
      });
      console.log(",1231231", module, pre, name);

      if (!module && pre) o[name].module = module;
    });
    console.log(o);

    return o;
  } finally {
    console.groupEnd();
  }
};

/** 判断单独的权限 */
export const judgeAlone = (alone: ALL_POWER, crs: string) => {
  const cType = useMainStore().customerInfo.cType;
  if (crs) {
    if (crs.startsWith("administrator")) return true;
    const arr = alone.split(",");
    // console.log(crs, arr, cType, "src");
    return arr.every((n) => {
      let s = n;
      if (cType) {
        if (n == "0202JZ") s = jzObj[cType];
        else if (["0902BS", "0904GS"].includes(n)) s = bsObj[cType];
      }
      // console.log(n, s, 1111);
      return crs.indexOf(s) != -1;
    });
  }
  return false;
};

export const strToNumber = {
  报表查询: POWER_FIANCE.NAME,
  报表导出: POWER_FIANCE.EXPORT,
  报表打印: POWER_FIANCE.PRINT,
};
/** 财务权限转换对应的权限编号 */
export const convertStr = (arr: ResAuthority["financialAuthority"]): string => {
  let newArr: string[] = [];
  Object.keys(strToNumber).forEach((key) => {
    if (arr.find((n) => n.columnName + n.authorityName == key)) newArr.push(strToNumber[key]);
  });
  console.log(newArr);
  return newArr.join(",");
};

export interface Powers {
  [key: string]: {
    module: boolean;
    [key: string]: boolean;
  };
}
